export default "__VITE_ASSET__834ba3e9__"